import {Component} from 'react';
import PropTypes from 'prop-types';

class TextInput extends Component {
    static defaultProps = {
        isInvalid: false,
        onChange: () => {}
    };

    static propTypes = {
        allowedRegex: PropTypes.instanceOf(RegExp),
        isInvalid: PropTypes.bool,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {value};
    }

    get value() {
        return this.refs.input.value;
    }

    getErrors(label = '') {
        if (!this.value) {
            return [`${label} is empty`];
        }
        return [];
    }

    onChange() {
        const {value: rawValue} = this;
        const {allowedRegex, onChange: propsOnChange} = this.props;

        let value = rawValue;

        if (allowedRegex instanceof RegExp) {
            value = rawValue.replace(allowedRegex, '');
        }

        this.setState({value});
        propsOnChange(value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    focus() {
        this.refs.input.focus();
        this.refs.input.select();
    }

    render() {
        const {value} = this.state;
        const {allowedRegex, isInvalid, ...theRest} = this.props;
        const style = isInvalid ? {border: '1px solid red'} : {};

        return (
            <input
                ref="input"
                type="text"
                {...theRest}
                style={style}
                onChange={this.onChange.bind(this)}
                value={value ? value : ''} />
        );
    }
}

export default TextInput;
